import { render, staticRenderFns } from "./createNews.vue?vue&type=template&id=2ee217fe&scoped=true&"
import script from "./createNews.vue?vue&type=script&lang=js&"
export * from "./createNews.vue?vue&type=script&lang=js&"
import style0 from "./createNews.vue?vue&type=style&index=0&id=2ee217fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee217fe",
  null
  
)

export default component.exports